import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 58BA7D31-6B34-46E6-B325-080C95B32A6F
 * name digital-ocean
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/digital-ocean.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const DigitalOceanIcon = createSvgIcon(<><path d="M6 12H2C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22V18H8V14H12V18C15.32 18 18 15.31 18 12C18 8.69 15.31 6 12 6C8.69 6 6 8.69 6 12M8 18V21H5V18H8M3 16H5V18H3V16Z" /></>, 'DigitalOceanIcon');
export default DigitalOceanIcon